<template>
  <div
    class="mats-listing__wrapper"
    style="flex-grow: 0.44; margin-top: 0px;"
    @click="removeLists"
  >
    <div class="not-toolbar">
      <div
        class="toolbar__row"
        style="width:50%"
      >
        <div
          class="search-filter"
        >
          <b-icon-search />
          <input
            v-model="searchMaterial"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t('MaterialName')"
            @keydown.down.prevent="arrowDown"
            @keydown.up.prevent="arrowUp"
            @keydown.enter.prevent="selectHighlighted"
          >
          <b-icon-x-circle
            class="search-filter__clear"
            :class="{ 'search-filter__clear--active': searchMaterial != '' }"
            @click="searchMaterial = ''"
          />
          <b-form-select
            v-model="selected"
            :options="options"
          />
          <div
            v-if="getFilteredMaterials.length > 0"
            ref="scrollContainer"
            class="search-filter__options"
          >
            <div
              v-for="(result, index) in getFilteredMaterials"
              :key="index"
              ref="options"
              :class="{ 'is-active': index === arrowCounter }"
              class="search-filter__option"
              @click="searchByOn(result);"
            >
              {{ result }}

            </div>
          </div>
        </div>
      </div>
      <button
        v-b-modal.modal-mat
        class="button"
        style="width:30%"
        @click="resetObject"
      >
        {{ $t('AddMaterial') }}
      </button>
    </div>

    <div
      class="tt"
    >
      <table
        class="team_table"
      >
        <thead>
          <tr>
            <th>
              {{ $t('No') }}
            </th>
            <th
              style="cursor: pointer"
              @click="sortByName"
            >
              {{ $t('MaterialName') }}
              <b-icon-sort-alpha-down v-if="sorted == false" />
              <b-icon-sort-alpha-up-alt v-else />
            </th>
            <th>
              {{ $t('Description') }}
            </th>
            <th>
              {{ $t('MeasurementType') }}
            </th>
            <th>
              {{ $t('Actions') }}
            </th>
          </tr>
        </thead>
        <LoadingSpinnerTable
        :is-loading="isRequestLoading('loadMaterials')"
        :responseData="getMaterials"
        >
          <tr
            v-for=" (material,index) in getMaterials"
            :key="material.materialId"
            class="hover-row"
            style="border-bottom: 1px solid #dcdfe6; color: #606266; cursor:pointer;"
            :style="classNameCh === material.materialId ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
            @click="matProps(material)"
          >
            <td>
              {{ getTotalItemsForMaterials - (page - 1) * pageSize - index }}.
            </td>
            <td>
              {{ material.name }}
            </td>
            <td>
              {{ material.description }}
            </td>

            <td>
              {{ formatMeasurementType(material.measurementType) }}
            </td>
            <td>
              <b-dropdown
                size="sm"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template #button-content>
                  <b-icon-three-dots-vertical
                    class="h6"
                    style="color:black"
                  />
                </template>
                <b-dropdown-item @click="editM(material)">
                  <span style="display:flex;gap:5px">
                    <b-icon-pencil />
                    <p>
                      {{ $t('Edit') }}
                    </p>
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>
        </LoadingSpinnerTable>
      </table>

    </div>
    <div>
      <b-pagination
        v-if="getTotalItemsForMaterials > 20"
        v-model="page"
        :total-rows="getTotalItemsForMaterials"
        :per-page="pageSize"
        first-number
        last-number
        align="fill"
        size="md"
        prev-class="prev-item"
        next-class="next-item"
        class="mt-1 mb-0"
      >
        <template #prev-text>
          <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
        </template>
        <template #next-text>
          <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
        </template>
      </b-pagination>
    </div>

    <AddRowModal
      :item="item"
      @materialvariant="addMaterialV"
    />

    <EditMaterial
      :edit-m="editMat"
      :add-edit="addEdit"
      @materialsEdit="updateMaterial"
      @materialsAdd="materialsData"
    />
  </div>
</template>

<script>
import EditMaterial from '@/modals/AddEditMaterial.vue'

import AddRowModal from '@/modals/AddRowModal.vue'

// eslint-disable-next-line no-unused-vars
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    EditMaterial,
    AddRowModal,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['rowsLengthData'],
  data() {
    return {
      skipWatch: false,
      searchFilterOptions: [
        {
          text: this.$t('Article'),
          value: true,
        },
        {
          text: this.$t('Code'),
          value: false,
        },
      ],
      toggleSearch: true,
      selected: null,
      options: [
        { value: null, text: this.$t('All') },
        { value: '0', text: this.$t('Meter') },
        { value: 'Meter_Square', text: this.$t('Meter_Square') },
        { value: '1', text: this.$t('Part') },
        { value: '2', text: this.$t('Package') },
        { value: '3', text: this.$t('BeadedStrand') },
        { value: '4', text: this.$t('Set') },
        { value: '5', text: this.$t('Pair') },
      ],
      addEdit: false,
      sorted: false,
      // initialId: '',
      materialPropId: '',
      classNameCh: '',
      editMat: {
        materialId: '',
        name: '',
        description: '',
        measurementType: '',
        created: '',
      },
      item: {
        materialId: '',
        name: '',
        measurementType: '',
      },
      page: 1,
      pageSize: 15,
      noSearch: false,
      searchMaterial: '',
      arrowCounter: -1,
      enterPressed: false,

    }
  },
  computed: {
    ...mapGetters(['getFilteredMaterials', 'getMaterials', 'getIsLoading', 'getCurrentPageForMaterials', 'getTotalItemsForMaterials', 'getMatVarCurrentPage', 'getTotalPriceByMaterialId']),
  },
  watch: {
    // initialId() {
    //   this.immediateId(this.initialId)
    // },
    page(value) {
      this.loadMaterials({
        pageNumber: value,
        pageSize: this.pageSize,
        materialName: this.searchMaterial,
        measurementType: this.selected == null ? 'ALL' : this.selected,
      })
    },
    searchMaterial(value) {
      if (this.skipWatch) {
        this.skipWatch = false;
        return;
      }

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value === '') {
          this.removeLists();
          this.loadMaterials({
            pageNumber: this.getCurrentPageForMaterials,
            pageSize: this.pageSize,
            materialName: this.searchMaterial,
            measurementType: this.selected == null ? 'ALL' : this.selected,
          })
        } else if (!this.enterPressed) {
          this.filteredMaterialsByName({
            materialName: value,
            measurementType: this.selected == null ? null : this.selected,
          });
        }
      }, 500);
    },
    selected(value) {
      this.loadMaterials({
        pageNumber: this.getCurrentPageForMaterials,
        pageSize: this.pageSize,
        materialName: this.searchMaterial,
        measurementType: value == null ? 'ALL' : value,
      })
      this.searchMaterial = '';
    },
  },
  mounted() {
    this.fetch()
    this.resetFilteredMaterials();
  },
  methods: {
    ...mapActions(['currentStockAmountMaterialId', 'totalPriceByMaterialId', 'filteredMaterialsByName', 'addMaterial', 'loadMaterials', 'editMaterialReq', 'loadMaterialVariant', 'addMaterialVariant', 'changeLoadingtoTrue', 'resetFilteredMaterials']),
    formatMeasurementType(value) {
      let name
      if (value === '0') {
        name = this.$t('Meter')
      } else if (value === '1') {
        name = this.$t('Part')
      } else if (value === '2') {
        name = this.$t('Package')
      } else if (value === '3') {
        name = this.$t('BeadedStrand')
      } else if (value === '4') {
        name = this.$t('Set')
      } else if (value === '5') {
        name = this.$t('Pair')
      } else if (value === 'Meter') {
        name = this.$t('Meter')
      } else if (value === 'Part') {
        name = this.$t('Part')
      } else if (value === 'Meter_Square') {
        name = this.$t('Meter_Square')
      } else {
        name = value
      }
      return name
    },
    async fetch() {
      try {
        // this.changeLoadingtoTrue(false)

        await this.loadMaterials({
          pageNumber: this.page,
          pageSize: this.pageSize,
          materialName: this.searchMaterial,
          measurementType: this.selected == null ? 'ALL' : this.selected,
        })
          .then((res) => {
            console.log(res);
            // this.changeLoadingtoTrue(true)
          })
      } catch (e) {
        console.log(e);
        // this.changeLoadingtoTrue(false)
      }
    },
    arrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFilteredMaterials.length - 1) {
        this.arrowCounter++;
        this.fixScrolling();
      }
    },
    arrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter--;
        this.fixScrolling();
      }
    },
    selectHighlighted() {
      if (this.arrowCounter >= 0 && this.getFilteredMaterials.length > 0) {
        this.searchByOn(this.getFilteredMaterials[this.arrowCounter]);
      }
    },
    fixScrolling() {
      this.$nextTick(() => {
        const options = this.$refs.options;
        const scrollContainer = this.$refs.scrollContainer?.$el;

        if (!options || !options[this.arrowCounter] || !scrollContainer) return;
        const selectedOption = options[this.arrowCounter];
        const optionHeight = selectedOption.clientHeight;

        const containerRect = scrollContainer.getBoundingClientRect();
        const selectedRect = selectedOption.getBoundingClientRect();

        if (selectedRect.bottom > containerRect.bottom) {
          scrollContainer.scrollTop += optionHeight;
        } else if (selectedRect.top < containerRect.top) {
          scrollContainer.scrollTop -= optionHeight;
        }
      });
    },
    editM(item) {
      this.addEdit = false
      this.editMat.materialId = item.materialId
      this.editMat.name = item.name
      this.editMat.description = item.description
      this.editMat.measurementType = item.measurementType
      this.editMat.created = item.created
      this.$bvModal.show('modal-edit-mat')
    },
    async updateMaterial(obj) {
      await this.editMaterialReq({
        object: obj,
        successCallback: () => {
          this.loadMaterials({
            pageNumber: this.getCurrentPageForMaterials,
            pageSize: this.pageSize,
            materialName: this.searchMaterial,
            measurementType: this.selected == null ? 'ALL' : this.selected,
          })
        },
      })
      this.$bvModal.hide('modal-edit-mat')
    },

    async addMaterialV(obj) {
      // console.log(location)

      await this.addMaterialVariant({
        object: obj,
        successCallback: () => {
          this.loadMaterialVariant({
            id: this.materialPropId,
            pageNumber: 1,
            pageSize: this.pageSize,
            successCallback: () => {

            },
          })
        },
      })
    },
    sortByName() {
      if (this.sorted == false) {
        this.getMaterials.sort((a, b) => {
          return a.name.localeCompare(b.name)
        })
        this.sorted = true
      } else {
        this.getMaterials.sort((a, b) => {
          return a.name > b.name ? -1 : 1
        })
        this.sorted = false
      }
    },
    getmaterial(mat) {
      this.item.materialId = mat.materialId
      this.item.measurementType = mat.measurementType
      this.item.name = mat.name
    },
    async materialsData(obj) {
      await this.addMaterial({
        object: obj,
        successCallback: () => {
          this.loadMaterials({
            pageNumber: 1,
            pageSize: this.pageSize,
            materialName: this.searchMaterial,
            measurementType: this.selected == null ? 'ALL' : this.selected,
          })
          this.page = 1
        },
      })
      this.editMat.materialId = ''
      this.editMat.name = ''
      this.editMat.description = ''
      this.editMat.measurementType = ''
      this.editMat.created = ''
      this.$bvModal.hide('modal-edit-mat')
    },
    resetObject() {
      this.addEdit = true
      this.$bvModal.show('modal-edit-mat')
      this.editMat.materialId = ''
      this.editMat.name = ''
      this.editMat.description = ''
      this.editMat.measurementType = ''
      this.editMat.created = ''
    },
    // immediateId(e) {
    //   this.$emit('click', e)
    // },
    matProps(mat) {
      // this.changeLoadingtoTrue(false)

      this.materialPropId = mat.materialId
      this.$emit('sendMaterial', mat)
      this.classNameCh = mat.materialId
      this.loadMaterialVariant({
        id: mat.materialId,
        pageNumber: 1,
        pageSize: this.pageSize,
        successCallback: () => {
          // this.changeLoadingtoTrue(true)
        },
      })
      this.totalPriceByMaterialId(
        mat.materialId,
      )
      this.getmaterial(mat)
      this.currentStockAmountMaterialId(
        mat.materialId,
      )
    },
    async searchByOn(value) {
      this.skipWatch = true;
      this.searchMaterial = value
      this.removeLists()
      await this.loadMaterials({
        pageNumber: this.getCurrentPageForMaterials,
        pageSize: this.pageSize,
        materialName: this.searchMaterial,
        measurementType: this.selected == null ? 'ALL' : this.selected,
      })
    },
    removeLists() {
      this.arrowCounter = -1
      this.resetFilteredMaterials();
    },
  },
}
</script>

<style scoped lang="scss">
.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
.mats-listing__wrapper {
  width: 600px !important;

  .tt {
    .vgt-table {
      th.sortable button {
        display: none !important;
      }
    }
  }

  .mats-listing {
    margin-top: 0;
  }
}
.next-item {
  padding-left: 85px !important;
}


.team_table td {
  padding: 9px 9px !important;
  text-align: left;
}

// .team_table .tr{
//   border-radius: 10px 10px 10px 10px !important;
// }


@media screen and (max-width: 1723px) {
  .mats-listing__wrapper {
    width: 400px !important;

    div {
      button {
        width: auto;
        height: 36px;
      }

      input {
        width: 160px;
      }

    }

    .table__search-input {
      padding-left: 0px;
      margin-left: 0px !important;
    }
  }

}

@media screen and (max-width: 1400px) {
  .mats-listing__wrapper {
    width: 100% !important;
  }
}


.dropdrop::-webkit-scrollbar {
  display: none;

}

.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}

.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

.is-active {
  background-color: #dedede;
}

// @media screen and (min-width: 1300px) and (max-width:1400px){
//   .team_table {
//     width: 94%;
//   }
// }
</style>
